export interface MorphingButtonConfig {
  /**
   * @description Enable morphing button functionality
   */
  enabled: boolean;
  /**
   * @description Specify the *querySelector* for scrollable area (e.g: .main-container)
   */
  scrollableSelector: string;
}
